<template>
    <div class="table-page"  v-if="loaded">
        <my-table :name="pageKey" :cols="cols" :data="list" :loading="loading" :page-param="page"
                  :batch="batch" :operate="operate"
                  @sort="sort"
                  @init="init" @refresh="getList" @pageChange="pageChange" @paramChange="paramChange" @cndClusterChange="cndClusterChange">
            <template #right>
                <el-button class="btn-blue" plain icon="el-icon-plus" @click="add" :disabled="'M_MA_MIC_I'|auth">添加</el-button>
            </template>
        </my-table>

        <common-add ref="add"  :dialog="editDialog" :cols="cols" @save="editSave" @delEdit="delEdit"></common-add>
        <common-detail :dialog="detailDialog" :cols="cols" @save="editSave"></common-detail>
    </div>
</template>

<script>
    import myMixin from '@/util/myMixin';
    import tableMixin from '@/util/tableMixin';


    export default {
        mixins: [tableMixin, myMixin],
        data() {
            return {
                loaded:true,
                pageKey: 'illegalCharacter',
                api: {
                    list: '/manage/illegalCharacter/findIllegalCharacterPage',   // 列表接口
                    detail: '/manage/illegalCharacter/findIllegalCharacterByPk', // 详情接口
                    add: '/manage/illegalCharacter/insertIllegalCharacter',      // 新增接口
                    update: '/manage/illegalCharacter/updateIllegalCharacter',   // 修改接口
                    del: '/manage/illegalCharacter/deleteIllegalCharacter',      // 删除接口
                    leadingOut: '/manage/illegalCharacter/exportIllegalCharacter',  // 导出接口
                },

                operate: [
                    {txt: '修改',type: 'primary', icon: 'el-icon-edit', event: this.update,auth: "M_MA_MIC_E"},
                    {txt: '详情', auth: '', type: 'success', icon: 'el-icon-view', event: this.detail},
                    {txt: '删除', type: 'danger', icon: 'el-icon-circle-close', event: this.del,auth: "M_MA_MIC_D"},
                ],

                // 批量操作的参数
                batch: [
                    {txt: '批量删除', api: '/manage/illegalCharacter/deleteIllegalCharacterList', power:'delete',auth:'M_MA_MIC_D'},
                    {txt: '批量导出', event: this.leadingOut, auth: ''},
                ],
                cols: [
                    {
                        key: "offendingCharacters",
                        value: "违规字符",
                        searchNormal: true,    // 允许普通筛选
                        searchAdvance: true,   // 允许高级筛选
                        viewList: true,        // 列表可现实
                        viewAdd: true,         // 新增可现实
                        viewEdit: true,        // 修改可现实
                        viewDetail:true,        // 详情
                        //minWidth: 200,       // 默认宽度200，但是可以扩大到占满表格
                        width: 150,            // 宽度
                    },
                    {
                        key: "remark",
                        value: "备注",
                        searchNormal: true,    // 允许普通筛选
                        searchAdvance: true,   // 允许高级筛选
                        viewList: true,        // 列表可现实
                        viewAdd: true,         // 新增可现实
                        viewEdit: true,        // 修改可现实
                        viewDetail:true,        // 详情
                        minWidth: 200,       // 默认宽度200，但是可以扩大到占满表格
                        //width: 200,            // 宽度
                        hideSort: true,        // 不排序
                    },
                    {
                        key: "makeName",
                        value: "创建人",
                        searchNormal: true,    // 允许普通筛选
                        searchAdvance: true,   // 允许高级筛选
                        viewList: true,        // 列表可现实
                        viewAdd: false,         // 新增可现实
                        viewEdit: false,        // 修改可现实
                        viewDetail:true,        // 详情
                        //minWidth: 200,       // 默认宽度200，但是可以扩大到占满表格
                        width: 150,            // 宽度
                    },
                    {
                        key: "makeTime",
                        value: "创建时间",
                        searchNormal: true,    // 允许普通筛选
                        searchAdvance: true,   // 允许高级筛选
                        viewList: true,        // 列表可现实
                        viewAdd: false,         // 新增可现实
                        viewEdit: false,        // 修改可现实
                        viewDetail:true,        // 详情
                        //minWidth: 200,       // 默认宽度200，但是可以扩大到占满表格
                        width: 150,            // 宽度
                        type: this.$variable.colType.DATE,
                    },
                    {
                        key: "modifyName",
                        value: "修改人",
                        searchNormal: true,    // 允许普通筛选
                        searchAdvance: true,   // 允许高级筛选
                        viewList: true,        // 列表可现实
                        viewAdd: false,         // 新增可现实
                        viewEdit: false,        // 修改可现实
                        viewDetail:true,        // 详情
                        //minWidth: 200,       // 默认宽度200，但是可以扩大到占满表格
                        width: 100,            // 宽度
                    },
                    {
                        key: "modifyTime",
                        value: "修改时间",
                        searchNormal: true,    // 允许普通筛选
                        searchAdvance: true,   // 允许高级筛选
                        viewList: true,        // 列表可现实
                        viewAdd: false,         // 新增可现实
                        viewEdit: false,        // 修改可现实
                        viewDetail:true,        // 详情
                        //minWidth: 200,       // 默认宽度200，但是可以扩大到占满表格
                        width: 150,            // 宽度
                        type: this.$variable.colType.DATE,
                    },
                ],
            }
        },
        methods: {
        },
        created() {
            // 枚举类型查询
            let dataCode = [];
            for (let i = 0; i < this.cols.length; i++) {
                if (this.cols[i].param && this.cols[i].param.dict) {
                    dataCode.push(this.cols[i].param.dict);
                }
            }
            if (dataCode.length !== 0) {
                this.$api.post('sys/dict/selectDictItemMap', dataCode)
                    .then(res => {
                        for (let i = 0; i < this.cols.length; i++) {
                            if (this.cols[i].param && this.cols[i].param.dict) {
                                let keyValue = {};
                                if(res[this.cols[i].param.dict]){
                                    for (let j = 0; j< res[this.cols[i].param.dict].length; j++){
                                        keyValue[res[this.cols[i].param.dict][j].itemDataCode] = res[this.cols[i].param.dict][j].itemDataName;
                                    }

                                    this.cols[i].param.keyValue = keyValue;
                                }
                            }
                        }
                        this.loaded = false;
                        this.$nextTick(() => {this.loaded = true});
                    });
            }
            //按钮权限查询
        },
    }
</script>


